var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReply(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 32 32",
    id: "i-reply",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "#5F7EFB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.2,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 6 L3 14 10 22 M3 14 L18 14 C26 14 30 18 30 26"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReply);
export default __webpack_public_path__ + "static/media/reply.e41a0f15d7290d4c93fde8eb85c88aa7.svg";
export { ForwardRef as ReactComponent };